<template>
    <div class="baseContent-warp">
        <el-card class="menu-card">
            <el-menu slot="header" :default-active="printType" mode="horizontal" @select="handleSelect">
                <el-menu-item v-for="item in printTypeList" :index="item.printType" :key="item.printType">{{ item.name
                }}</el-menu-item>
            </el-menu>
            <div class="display-f flex-col borderBox" style="height:100%;">
                <div style="flex-grow: 1;padding:16px;width:525px;">
                    <div class="colorFE8F size14" style="padding: 8px 16px;background:#FFF0E1;"><i
                            class="el-icon-warning colorFE8 "></i>您正在为{{ formatterName() }}配置打印机，请确认当前所处的医馆为{{
                                formatterName() }}</div>
                    <div>
                        <div v-for="item in printList" :key="item.id" class="mt16 size14 color1F23">
                            <div style="border-left:3px solid #1890FF;" class="pl3 ">设置{{ item.name }}默认打印设备：
                            </div>
                            <div v-if="item.id == '2'" class="color6671 mt8">提示：当您未设置个人默认打印设备时，我们将选择门店默认打印设备为您服务</div>
                            <div class="mt8" style="padding:0px 16px 16px; background:#F9F9FA;overflow: hidden;">
                                <div v-for="kid in item.list" :key="kid.clientId">
                                    <div class="mt16 display-f align-i-c"><i class="iconfont icon-diannao color9AA0 mr3" style=""></i><span>客户端：{{ kid.hostName }}</span></div>
                                    <div>
                                        <el-radio-group v-if="item.id == '1'" v-model="deptPrintDefaultId" @input="changePrint(kid.clientId,1)">
                                            <div class="mt12" v-for="k in kid.printerInfos" :key="k.id">
                                                <el-radio :label="k.id">{{ k.printerName }}</el-radio>

                                            </div>
                                        </el-radio-group>
                                        <el-radio-group v-if="item.id == '2'" v-model="userPrintDefaultId" @input="changePrint(kid.clientId,2)">
                                            <div class="mt12" v-for="k in kid.printerInfos" :key="k.id">
                                                <el-radio :label="k.id">{{ k.printerName }}</el-radio>

                                            </div>
                                        </el-radio-group>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>

                </div>

                <div class="borderEBE-t display-f align-i-c borderBox" style="height:64px;padding:16px;">
                    <custom-button type="primary" @click="savePrintDialog = true">保存修改</custom-button>
                </div>
            </div>
        </el-card>
        <custom-dialog :visible="savePrintDialog" type="info" title="信息提示" @close="savePrintDialog = false" width="358px"
            @save="savePrintSetting">
            <div slot="content" class="color1F23 size14">
                确定修改<span style="font-weight: 600;">{{ formatterName() }}</span>的默认打印设备？
            </div>
        </custom-dialog>
    </div>
</template>

<script>
import { PrintDto } from '@/DTO';
import CustomDialog from '@/components/customDialog/CustomDialog.vue'
export default {
    components: { CustomDialog },
    data() {
        return {
            deptId: this.$session.get('deptId'), // 当前医馆id
            deptOptions: this.$session.get('options'), // 当前所有医馆
            printTypeList: [],//打印机类型
            printType: '1',
            printList: [
                { id: 2, name: '个人', list: [] },
                { id: 1, name: '门店', list: [] },
            ],
            deptPrintDefaultId:null,//医馆选中id
            deptPrintDefault: {//医馆默认打印机
                printerName: null,
                clientId: null
            },
            userPrintDefaultId:null,//个人选中id
            userPrintDefault: {//个人默认打印机
                printerName: null,
                clientId: null
            },
            savePrintDialog: false,//保存打印机弹窗,
            printListAll:[]
        }
    },
    computed: {
        //处理门店名称
        formatterName() {
            let that = this
            return function () {
                return that.deptOptions.filter(val => val.value == that.deptId)[0].label

            }
        },
    },
    created() {
        this.init()
    },
    methods: {
        init(){
            this.getPrintType();
        this.getPrintList();
        },
        //获取打印类型
        getPrintType() {
            PrintDto.getPrintType({ deptId: this.deptId }).then(res => {
                if (res.code == 200) {
                    this.printTypeList = res.data
                }
            })
        },
        //获取打印机列表
        getPrintList() {
            PrintDto.getPrintClientList().then(res => {
                if (res.code == 200) {
                    if (!_.isEmpty(res.data)) {
                        this.printListAll=res.data
                        this.printList.forEach(val => {
                            val.list = res.data
                        })
                        this.getDefaultPrint()
                    }
                }
            })
        },
        //查询默认打印机
        getDefaultPrint() {
            let obj = {
                deptId: this.deptId,
                printType: this.printType
            }
            PrintDto.getPrintDefault(obj).then(res => {
                if(res.data.deptPrintDefault){
                   let deptPrintDefaultId=res.data.deptPrintDefault.clientId+res.data.deptPrintDefault.printerName
                    let arr=PrintDto.computeHasPrint(this.printListAll,deptPrintDefaultId)
                    if(!_.isEmpty(arr)){
                        this.deptPrintDefaultId=deptPrintDefaultId
                        this.deptPrintDefault = Object.assign({}, this.deptPrintDefault, res.data.deptPrintDefault)
                    }
                   
                }
                if(res.data.userPrintDefault){
                    let userPrintDefaultId=res.data.userPrintDefault.clientId+res.data.userPrintDefault.printerName
                    let arr=PrintDto.computeHasPrint(this.printListAll,userPrintDefaultId)
                    if(!_.isEmpty(arr)){
                        this.userPrintDefaultId=userPrintDefaultId
                        this.userPrintDefault = Object.assign({}, this.deptPrintDefault, res.data.userPrintDefault)
                    }
                }
               
               
               
            })
        },
        //保存默认设置
        savePrintSetting() {
            let obj = {
                deptId: this.deptId,
                printType: this.printType,
            }
            if(this.deptPrintDefault.clientId){
                obj.deptPrintDefault=this.deptPrintDefault
            }
            if(this.userPrintDefault.clientId){
                obj.userPrintDefault=this.userPrintDefault
            }
            PrintDto.editPrintDefault(obj).then(res => {
                this.savePrintDialog = false;
                if (res.code == 200) {
                    this.$message.success('保存成功！')
                }
            })

        },
        // 切换当前显示组件
        handleSelect(key) {
           this.deptPrintDefaultId=null,//医馆选中id
           this.deptPrintDefault= {//医馆默认打印机
                printerName: null,
                clientId: null
            },
           this.userPrintDefaultId=null,//个人选中id
           this.userPrintDefault={//个人默认打印机
                printerName: null,
                clientId: null
            },
            this.printType = key;
            this.getPrintList()
            console.log('this.printType',this.printType);
        },
        //打印机切换改变
        changePrint(clientId,type){
            if(type=='1'){
                this.deptPrintDefault.clientId=clientId
                let deptPrintDefaultId=_.cloneDeep(this.deptPrintDefaultId)
                this.deptPrintDefault.printerName=deptPrintDefaultId.replace(clientId,'')
            }else if(type=='2'){
                this.userPrintDefault.clientId=clientId
                let userPrintDefaultId=_.cloneDeep(this.userPrintDefaultId)
                this.userPrintDefault.printerName=userPrintDefaultId.replace(clientId,'')

            }
        }

    }
}
</script>

<style lang="less" scoped>
.menu-card {
    display: flex;
    flex-direction: column;

    /deep/.el-card__body {
        flex: 1;
        padding: 0;
    }

}
</style>